import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = <div className="space-y-6 text-gray-300" data-id="element-63">
    <h3 className="text-2xl font-bold text-white" data-id="element-64">Política de Privacidad</h3>
    <p data-id="element-65">
      Última actualización:{' '}
      {new Date().toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })}
    </p>

    <h4 className="text-lg font-semibold text-white" data-id="element-66">
      1. Información que Recopilamos
    </h4>
    <p data-id="element-67">
      Recopilamos únicamente la información necesaria para procesar tu compra y
      entregar el producto digital: nombre y dirección de correo electrónico.
    </p>

    <h4 className="text-lg font-semibold text-white" data-id="element-68">
      2. Uso de la Información
    </h4>
    <p data-id="element-69">Tu información personal se utiliza exclusivamente para:</p>
    <ul className="list-disc pl-6 space-y-2" data-id="element-70">
      <li data-id="element-71">Entregar el producto digital adquirido a tu correo electrónico.</li>
      <li data-id="element-72">Enviar actualizaciones relacionadas con tu compra.</li>
      <li data-id="element-73">Brindarte soporte en caso de que lo necesites.</li>
    </ul>

    <h4 className="text-lg font-semibold text-white" data-id="element-74">3. Protección de Datos</h4>
    <p data-id="element-75">
      Implementamos medidas de seguridad estándar de la industria para proteger
      tu información personal. No vendemos, intercambiamos ni transferimos tu
      información a terceros.
    </p>

    <h4 className="text-lg font-semibold text-white" data-id="element-76">4. Cookies</h4>
    <p data-id="element-77">
      Nuestro sitio puede utilizar cookies para mejorar la experiencia del
      usuario. Puedes configurar tu navegador para rechazar cookies si lo
      prefieres.
    </p>

    <h4 className="text-lg font-semibold text-white" data-id="element-78">5. Tus Derechos</h4>
    <p data-id="element-79">
      Tienes derecho a acceder, rectificar o eliminar tus datos personales en
      cualquier momento.
    </p>
  </div>;
const termsContent = <div className="space-y-6 text-gray-300" data-id="element-80">
    <h3 className="text-2xl font-bold text-white" data-id="element-81">Términos y Condiciones</h3>
    <p data-id="element-82">
      Última actualización:{' '}
      {new Date().toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })}
    </p>

    <h4 className="text-lg font-semibold text-white" data-id="element-83">1. Producto Digital</h4>
    <p data-id="element-84">
      "El Código de Insulina 55+" es un producto digital de carácter informativo
      y educativo. Se entrega en formato electrónico inmediatamente después de
      la compra.
    </p>

    <h4 className="text-lg font-semibold text-white" data-id="element-85">
      2. Descargo de Responsabilidad Médica
    </h4>
    <p data-id="element-86">
      Este producto no sustituye el consejo médico profesional, diagnóstico o
      tratamiento. Siempre consulte a su médico antes de comenzar cualquier
      programa de nutrición o cambio en su dieta, especialmente si toma
      medicación.
    </p>

    <h4 className="text-lg font-semibold text-white" data-id="element-87">3. Resultados</h4>
    <p data-id="element-88">
      Los resultados pueden variar de persona a persona. Los testimonios y
      ejemplos mencionados son resultados individuales y no garantizan que
      obtendrás los mismos resultados.
    </p>

    <h4 className="text-lg font-semibold text-white" data-id="element-89">
      4. Propiedad Intelectual
    </h4>
    <p data-id="element-90">
      Todo el contenido del producto está protegido por derechos de autor. Queda
      prohibida su reproducción, distribución o reventa sin autorización
      expresa.
    </p>

    <h4 className="text-lg font-semibold text-white" data-id="element-91">
      5. Política de Reembolso
    </h4>
    <p data-id="element-92">
      Debido a la naturaleza digital del producto y su entrega inmediata, todas
      las ventas son finales. Si tienes algún problema con tu compra, no dudes
      en contactarnos.
    </p>

    <h4 className="text-lg font-semibold text-white" data-id="element-93">6. Modificaciones</h4>
    <p data-id="element-94">
      Nos reservamos el derecho de modificar estos términos en cualquier
      momento. Las modificaciones entrarán en vigor inmediatamente después de su
      publicación.
    </p>
  </div>;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-navy-900 py-8 text-center border-t border-navy-800" data-id="element-95">
        <p className="text-gray-500 text-sm" data-id="element-96">
          © {new Date().getFullYear()} El Código de Insulina 55+. Todos los
          derechos reservados.
        </p>
        <p className="text-gray-600 text-xs mt-2 max-w-2xl mx-auto px-4" data-id="element-97">
          Este producto no sustituye el consejo médico profesional. Consulte a
          su médico antes de comenzar cualquier programa de nutrición.
        </p>
        <div className="flex justify-center space-x-6 mt-4" data-id="element-98">
          <button onClick={() => setActiveModal('privacy')} className="text-gray-500 hover:text-brand-light text-sm underline underline-offset-2 transition-colors" data-id="element-99">
            Política de Privacidad
          </button>
          <button onClick={() => setActiveModal('terms')} className="text-gray-500 hover:text-brand-light text-sm underline underline-offset-2 transition-colors" data-id="element-100">
            Términos y Condiciones
          </button>
        </div>
      </footer>

      {/* Modal */}
      <AnimatePresence data-id="element-101">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-102">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3
        }} className="bg-navy-800 border border-navy-700 rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-8 relative shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-103">
              <button onClick={() => setActiveModal(null)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors p-1 rounded-lg hover:bg-navy-700" aria-label="Cerrar" data-id="element-104">
                <XIcon className="w-6 h-6" data-id="element-105" />
              </button>

              {activeModal === 'privacy' ? privacyContent : termsContent}
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}